module.exports = __webpack_public_path__ + "img/ico-10-active.f3eaccdd.svg";